import { Model } from 'pinia-orm';
import { Attr, BelongsTo, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import ReportSectionConfig from './ReportSectionConfig';
/* --- user header --- */
/* --- end user header --- */

export default class ReportSection extends Model {
  static entity = 'App\\Models\\ReportSection';
  // fields
  @Num(0)
  declare id: number;
  @Str('')
  declare name: string;
  @Str('')
  declare renderer_class: string;
  @Str('')
  declare description: string;
  @Attr(undefined)
  declare parameters: unknown[] | undefined;
  @Str('')
  declare contents_title: string;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  // relations
  @HasMany(() => ReportSectionConfig, 'report_section_id', 'id')
  declare report_section_configs: ReportSectionConfig[];
  /* --- end user code --- */
}
